import Quill from "quill";

const Parchment = Quill.import("parchment");
const Block = Quill.import("blots/block");
const Container = Quill.import("blots/container");

class CodeBlockItem extends Block {
  static blotName = "code_block_item";
  static tagName = "PRE";
  static className = "ql-code_block_item";

  static create(value) {
    let node = super.create(value);
    node.setAttribute("spellcheck", false);
    node.style.cssText = "white-space: pre-wrap";
    return node;
  }

  static formats() {
    return true;
  }

  format(name, value) {
    if (name === CodeBlock.blotName && (!this.domNode.textContent || !value)) {
      if (value) this.next && this.next.remove();
      this.replaceWith(Parchment.create(this.statics.scope));
    } else {
      super.format(name, value);
    }
  }

  formatAt(index, length, name, value) {
    if (length === 0) return;
    if (
      name === CodeBlock.blotName &&
      value === this.statics.formats(this.domNode)
    ) {
      this.format(name, value);
    }
  }

  remove() {
    if (this.prev == null && this.next == null) {
      this.next?.remove();
    } else {
      super.remove();
    }
  }

  replaceWith(name, value) {
    this.parent.isolate(this.offset(this.parent), this.length());
    if (name === this.parent.statics.blotName) {
      this.parent.replaceWith(name, value);
      return this;
    } else {
      this.parent.unwrap();
      return super.replaceWith(name, value);
    }
  }
}

class CodeBlock extends Container {
  static blotName = "code_block";
  static scope = Parchment.Scope.BLOCK_BLOT;
  static tagName = "DIV";
  static defaultChild = "code_block_item";
  static allowedChildren = [CodeBlockItem];
  static className = "ql-code_block";

  static create(value) {
    let node = super.create(value);
    return node;
  }

  static formats(domNode) {
    if (domNode.tagName === "DIV") return true;
    return undefined;
  }

  formats() {
    return { [this.statics.blotName]: this.statics.formats(this.domNode) };
  }

  optimize(context) {
    super.optimize(context);
    let next = this.next;
    if (
      next != null &&
      next.prev === this &&
      next.statics.blotName === this.statics.blotName &&
      next.domNode.tagName === this.domNode.tagName
    ) {
      next.moveChildren(this);
      next.remove();
    }
  }

  replace(target) {
    if (target.statics.blotName !== this.statics.blotName) {
      let item = Parchment.create(this.statics.defaultChild);
      target.moveChildren(item);
      this.appendChild(item);
    }
    super.replace(target);
  }
}

export { CodeBlock, CodeBlockItem };
